/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "wčera",
        "0": "dźensa",
        "1": "jutře",
        "future": {
          "few": "za {0} dny",
          "one": "za {0} dźeń",
          "other": "za {0} dnjow",
          "two": "za {0} dnjej"
        },
        "past": {
          "few": "před {0} dnjemi",
          "one": "před {0} dnjom",
          "other": "před {0} dnjemi",
          "two": "před {0} dnjomaj"
        }
      },
      "day-narrow": {
        "-1": "wč.",
        "0": "dźe.",
        "1": "jut.",
        "future": {
          "few": "za {0} d",
          "one": "za {0} d",
          "other": "za {0} d",
          "two": "za {0} d"
        },
        "past": {
          "few": "před {0} d",
          "one": "před {0} d",
          "other": "před {0} d",
          "two": "před {0} d"
        }
      },
      "day-short": {
        "-1": "wčer.",
        "0": "dźens.",
        "1": "jutř.",
        "future": {
          "few": "za {0} dny",
          "one": "za {0} dźeń",
          "other": "za {0} dnj.",
          "two": "za {0} dnj."
        },
        "past": {
          "few": "před {0} dnj.",
          "one": "před {0} dnj.",
          "other": "před {0} dnj.",
          "two": "před {0} dnj."
        }
      },
      "hour": {
        "0": "w tutej hodźinje",
        "future": {
          "few": "za {0} hodźiny",
          "one": "za {0} hodźinu",
          "other": "za {0} hodźin",
          "two": "za {0} hodźinje"
        },
        "past": {
          "few": "před {0} hodźinami",
          "one": "před {0} hodźinu",
          "other": "před {0} hodźinami",
          "two": "před {0} hodźinomaj"
        }
      },
      "hour-narrow": {
        "0": "w tutej hodźinje",
        "future": {
          "few": "za {0} h",
          "one": "za {0} h",
          "other": "za {0} h",
          "two": "za {0} h"
        },
        "past": {
          "few": "před {0} h",
          "one": "před {0} h",
          "other": "před {0} h",
          "two": "před {0} h"
        }
      },
      "hour-short": {
        "0": "w tutej hodźinje",
        "future": {
          "few": "za {0} hodź.",
          "one": "za {0} hodź.",
          "other": "za {0} hodź.",
          "two": "za {0} hodź."
        },
        "past": {
          "few": "před {0} hodź.",
          "one": "před {0} hodź.",
          "other": "před {0} hodź.",
          "two": "před {0} hodź."
        }
      },
      "minute": {
        "0": "w tutej mjeńšinje",
        "future": {
          "few": "za {0} minuty",
          "one": "za {0} minutu",
          "other": "za {0} minutow",
          "two": "za {0} minuće"
        },
        "past": {
          "few": "před {0} minutami",
          "one": "před {0} minutu",
          "other": "před {0} minutami",
          "two": "před {0} minutomaj"
        }
      },
      "minute-narrow": {
        "0": "w tutej mjeńšinje",
        "future": {
          "few": "za {0} m",
          "one": "za {0} m",
          "other": "za {0} m",
          "two": "za {0} m"
        },
        "past": {
          "few": "před {0} m",
          "one": "před {0} m",
          "other": "před {0} m",
          "two": "před {0} m"
        }
      },
      "minute-short": {
        "0": "w tutej mjeńšinje",
        "future": {
          "few": "za {0} min.",
          "one": "za {0} min.",
          "other": "za {0} min.",
          "two": "za {0} min."
        },
        "past": {
          "few": "před {0} min.",
          "one": "před {0} min.",
          "other": "před {0} min.",
          "two": "před {0} min."
        }
      },
      "month": {
        "-1": "zašły měsac",
        "0": "tutón měsac",
        "1": "přichodny měsac",
        "future": {
          "few": "za {0} měsacy",
          "one": "za {0} měsac",
          "other": "za {0} měsacow",
          "two": "za {0} měsacaj"
        },
        "past": {
          "few": "před {0} měsacami",
          "one": "před {0} měsacom",
          "other": "před {0} měsacami",
          "two": "před {0} měsacomaj"
        }
      },
      "month-narrow": {
        "-1": "zaš. měsac",
        "0": "tu. měsac",
        "1": "přich. měsac",
        "future": {
          "few": "za {0} měs.",
          "one": "za {0} měs.",
          "other": "za {0} měs.",
          "two": "za {0} měs."
        },
        "past": {
          "few": "před {0} měs.",
          "one": "před {0} měs.",
          "other": "před {0} měs.",
          "two": "před {0} měs."
        }
      },
      "month-short": {
        "-1": "zašł. měsac",
        "0": "tut. měsac",
        "1": "přichodn. měsac",
        "future": {
          "few": "za {0} měs.",
          "one": "za {0} měs.",
          "other": "za {0} měs.",
          "two": "za {0} měs."
        },
        "past": {
          "few": "před {0} měs.",
          "one": "před {0} měs.",
          "other": "před {0} měs.",
          "two": "před {0} měs."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "zašły kwartal",
        "0": "tutón kwartal",
        "1": "přichodny kwartal",
        "future": {
          "few": "za {0} kwartale",
          "one": "za {0} kwartal",
          "other": "za {0} kwartalow",
          "two": "za {0} kwartalej"
        },
        "past": {
          "few": "před {0} kwartalemi",
          "one": "před {0} kwartalom",
          "other": "před {0} kwartalemi",
          "two": "před {0} kwartalomaj"
        }
      },
      "quarter-narrow": {
        "-1": "zašły kwartal",
        "0": "tutón kwartal",
        "1": "přichodny kwartal",
        "future": {
          "few": "za {0} kw.",
          "one": "za {0} kw.",
          "other": "za {0} kw.",
          "two": "za {0} kw."
        },
        "past": {
          "few": "před {0} kw.",
          "one": "před {0} kw.",
          "other": "před {0} kw.",
          "two": "před {0} kw."
        }
      },
      "quarter-short": {
        "-1": "zašły kwartal",
        "0": "tutón kwartal",
        "1": "přichodny kwartal",
        "future": {
          "few": "za {0} kwart.",
          "one": "za {0} kwart.",
          "other": "za {0} kwart.",
          "two": "za {0} kwart."
        },
        "past": {
          "few": "před {0} kwart.",
          "one": "před {0} kwart.",
          "other": "před {0} kwart.",
          "two": "před {0} kwart."
        }
      },
      "second": {
        "0": "nětko",
        "future": {
          "few": "za {0} sekundy",
          "one": "za {0} sekundu",
          "other": "za {0} sekundow",
          "two": "za {0} sekundźe"
        },
        "past": {
          "few": "před {0} sekundami",
          "one": "před {0} sekundu",
          "other": "před {0} sekundami",
          "two": "před {0} sekundomaj"
        }
      },
      "second-narrow": {
        "0": "nětko",
        "future": {
          "few": "za {0} s",
          "one": "za {0} s",
          "other": "za {0} s",
          "two": "za {0} s"
        },
        "past": {
          "few": "před {0} s",
          "one": "před {0} s",
          "other": "před {0} s",
          "two": "před {0} s"
        }
      },
      "second-short": {
        "0": "nětko",
        "future": {
          "few": "za {0} sek.",
          "one": "za {0} sek.",
          "other": "za {0} sek.",
          "two": "za {0} sek."
        },
        "past": {
          "few": "před {0} sek.",
          "one": "před {0} sek.",
          "other": "před {0} sek.",
          "two": "před {0} sek."
        }
      },
      "week": {
        "-1": "zašły tydźeń",
        "0": "tutón tydźeń",
        "1": "přichodny tydźeń",
        "future": {
          "few": "za {0} tydźenje",
          "one": "za {0} tydźeń",
          "other": "za {0} tydźenjow",
          "two": "za {0} tydźenjej"
        },
        "past": {
          "few": "před {0} tydźenjemi",
          "one": "před {0} tydźenjom",
          "other": "před {0} tydźenjemi",
          "two": "před {0} tydźenjomaj"
        }
      },
      "week-narrow": {
        "-1": "zaš. tydźeń",
        "0": "tu. tydźeń",
        "1": "přich. tydźeń",
        "future": {
          "few": "za {0} tydź.",
          "one": "za {0} tydź.",
          "other": "za {0} tydź.",
          "two": "za {0} tydź."
        },
        "past": {
          "few": "před {0} tydź.",
          "one": "před {0} tydź.",
          "other": "před {0} tydź.",
          "two": "před {0} tydź."
        }
      },
      "week-short": {
        "-1": "zašł. tydźeń",
        "0": "tut. tydźeń",
        "1": "přichodn. tydźeń",
        "future": {
          "few": "za {0} tydź.",
          "one": "za {0} tydź.",
          "other": "za {0} tydź.",
          "two": "za {0} tydź."
        },
        "past": {
          "few": "před {0} tydź.",
          "one": "před {0} tydź.",
          "other": "před {0} tydź.",
          "two": "před {0} tydź."
        }
      },
      "year": {
        "-1": "loni",
        "0": "lětsa",
        "1": "klětu",
        "future": {
          "few": "za {0} lěta",
          "one": "za {0} lěto",
          "other": "za {0} lět",
          "two": "za {0} lěće"
        },
        "past": {
          "few": "před {0} lětami",
          "one": "před {0} lětom",
          "other": "před {0} lětami",
          "two": "před {0} lětomaj"
        }
      },
      "year-narrow": {
        "-1": "lo.",
        "0": "lět.",
        "1": "klě.",
        "future": {
          "few": "za {0} l.",
          "one": "za {0} l.",
          "other": "za {0} l.",
          "two": "za {0} l."
        },
        "past": {
          "few": "před {0} l.",
          "one": "před {0} l.",
          "other": "před {0} l.",
          "two": "před {0} l."
        }
      },
      "year-short": {
        "-1": "lon.",
        "0": "lěts.",
        "1": "klět.",
        "future": {
          "few": "za {0} l.",
          "one": "za {0} l.",
          "other": "za {0} l.",
          "two": "za {0} l."
        },
        "past": {
          "few": "před {0} l.",
          "one": "před {0} l.",
          "other": "před {0} l.",
          "two": "před {0} l."
        }
      }
    },
    "locale": "hsb"
  });
}